// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./controllers/hotwire_combobox"

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)

import * as bootstrap from "bootstrap"
